
import Vue from "vue";

export default Vue.extend({
  data() {
    return {
      selected: window.location.href.split("/")[4] || "home",
    };
  },
  methods: {
    setSelected(selected: string) {
      if (this.selected !== selected) {
        this.selected = selected;
        if (selected === "home") {
          this.$router.push("/");
        } else {
          this.$router.push(`/${selected}`);
        }
      }
    },
    isSelected(page: string) {
      if (this.selected === page) {
        return "selected";
      }
    },
    isSelectedIcon(page: string) {
      if (this.selected === page) {
        return "selectedicon";
      }
    },
  },
  watch: {
    $route(to) {
      this.selected = to.path.split("/")[1] || "home";
    },
  },
});
